<template>
	<div v-if="$store.getters.user">
		<Sidebar></Sidebar>
		<Header></Header>
		<div class="main main-app p-3 p-lg-4">
			<router-view />
		</div>
	</div>
	<div v-else>
		<router-view />
	</div>
</template>
<script>
import Sidebar from "./components/Sidebar.vue";
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import moment from 'moment';

export default {
	name: 'App',
	components: { Sidebar, Header, Footer },

	created() {
		// Read the status information in sessionStorage when the page is loaded
		if (sessionStorage.getItem("user")) {
			this.$store.dispatch('setUser', JSON.parse(sessionStorage.getItem("user")))
			sessionStorage.removeItem('user')
		}
		if (sessionStorage.getItem("token")) {
			this.$store.dispatch('setToken', sessionStorage.getItem("token"))
			sessionStorage.removeItem('token')
		}
		if (sessionStorage.getItem("school_search")) {
			this.$store.dispatch('setSchoolSearch', JSON.parse(sessionStorage.getItem("school_search")))
			sessionStorage.removeItem('school_search')
		}


		// if (sessionStorage.getItem("permissions")) {
		// 	this.$store.dispatch('setPermissions', JSON.parse(sessionStorage.getItem("permissions")))
		// 	sessionStorage.removeItem('permissions')
		// }
		// //Save the information in vuex to sessionStorage when the page is refreshed
		// window.addEventListener("beforeunload", () => {
		// 	sessionStorage.setItem("user", JSON.stringify(this.$store?.getters?.user))
		// 	sessionStorage.setItem("token", this.$store?.getters?.token)
		// 	sessionStorage.setItem("permissions", JSON.stringify(this.$store?.getters?.permissions))
		// })

		// if(localStorage.getItem('page_close_at')){
		// let pca = localStorage.getItem('page_close_at')
		// let time_diff = moment().diff(pca, 'day')
		// if(time_diff < 1){

		// if (localStorage.getItem("user")) {
		// 	this.$store.dispatch('setUser', JSON.parse(localStorage.getItem("user")))
		// }
		// if (localStorage.getItem("token")) {
		// 	this.$store.dispatch('setToken', localStorage.getItem("token"))
		// }
		// if (localStorage.getItem("permissions")) {
		// 	this.$store.dispatch('setPermissions', JSON.parse(localStorage.getItem("permissions")))
		// }
		// 	}else{
		// 		localStorage.clear()
		// 	}
		// }else{
		// 	localStorage.clear()
		// }


		//Save the information in vuex to localStorage when the page is refreshed
		window.addEventListener("beforeunload", () => {
			sessionStorage.setItem("user", JSON.stringify(this.$store?.getters?.user));
            sessionStorage.setItem("token", this.$store?.getters?.token);
			sessionStorage.setItem("school_search", JSON.stringify(this.$store?.getters?.school_search));
			// localStorage.setItem("permissions", JSON.stringify(this.$store?.getters?.permissions))
			// localStorage.setItem('page_close_at', moment().format('YYYY-MM-DD HH:mm:ss'))
		})


	}
};
</script>
<style>
.icon_hgt {
    font-size: 16px;
    vertical-align: middle;
}
.width-75{
    width: 75px;
}
.card1{
	display: flex;
    justify-content: space-between;
    align-items: center;
}
.fs-30{
	font-size: 30px;
}
.br-16{
	border-radius: 16px;
}

</style>